angular.module('rjmNg.services').factory 'tourService', [
  "$q"
  "Charts"
  "reportBuilder"
  "$routeParams"
  "$url"
  "$clientAppUrl"

  ($q, Charts, reportBuilder, $routeParams, $url, $clientAppUrl) ->
    
    tourService = {}

    tourService.getVrbChart = () ->
      deferred = $q.defer()

      Charts.getCharts().then( (data) ->
        try
          charts = data
          for chart in charts when chart.reportQueryType is "rjql"
            deferred.resolve(chart)
            return
        catch error
          deferred.reject(error)
          return
      )
      return deferred.promise

    tourService.getVrbUrl = (figureId) ->
      reportPath = reportBuilder.getReportBuilderPath(figureId, "rjql")
      if reportPath?
        return $url("/" + reportPath)
      else 
        if $routeParams.dashboardId?
          dashboardParams = "?dashboardId=#{$routeParams.dashboardId}"
          return $clientAppUrl("/reports/create#{dashboardParams}")
        else
          return $clientAppUrl("/reports/create")

    tourService
  ]
